
import carInput from "@/components/carInput.vue";
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {
components: {
carInput,
Flexbox,
FlexboxItem,
Group,
Cell,
XButton,
XInput,
Divider,
Selector,
XTable,
},
watch: {},
methods: {
closePlate() {
let that = this;

that.$bus.emit("closePlateSelector", null);
},
showPlateSelector() {
this.$bus.emit("showPlateSelector", null);
},
get_wxid_history(wxid) {
let that = this;
console.log("wxid=");
if (wxid == "") return;
var code_url = "/api/v1/get_wxid_history/" + wxid;
that.$http.post(code_url).then((ret) => {
console.log(ret.data);
console.log(ret.data.history);
if (ret.data.history.length > 0) {
var hisDatas = ret.data.history.split("|");
for (var item of hisDatas) {
if (item.indexOf(",") > -1) {
var single = item.split(",");
var newData = {
time: single[0],
gap: single[1],
dh: single[2],
dh1: single[3],
location: single[4],
};

that.history_data.push(newData);
}
}
}
});
},
init() {
let that = this;
/*
var url =
"/api/v1/get_wx_config/" +
encodeURIComponent(location.href.split("#")[0]);

that.$http.post(url).then((ret) => {
console.log(ret);
that.$wechat.config(ret.data);
});
*/


that.wx_id = that.$cookies.get("wx_id");


if (
that.wx_id == undefined ||
that.wx_id == null ||
that.wx_id == "" ||
that.wx_id == "null" ||
that.wx_id == "undefined"
) {
var code = that.getQueryValue("code");
var code_url = "/api/v1/get_page_token/" + code;
that.$http.post(code_url).then((ret) => {
console.log(JSON.stringify(ret.data));
if (ret.data.openid == undefined || ret.data.openid == "") {
that.$vux.alert.show({
title: "系统错误",
content: "获取微信数据失败，请退出系统从入口重新进入。",
onShow() {},
onHide() {},
});

return;
}

that.wx_id = ret.data.openid;
that.$cookies.set("wx_id", that.wx_id);
that.get_wxid_history(that.wx_id);
});
} else that.get_wxid_history(that.wx_id);
},

getQueryValue(queryName) {
let that = this;
var query = decodeURIComponent(window.location.href.split("?")[1]);
var vars = query.split("&");
for (var i = 0; i < vars.length; i++) {
var pair = vars[i].split("=");
if (pair[0] == queryName) {
return pair[1];
}
}
return null;
},

check_id() {
let that = this;
let Base64 = require("js-base64").Base64;
var url =
"/api/v1/check_id/" +
Base64.encode(
that.$cookies.get("wx_id") +
"," +
that.phone +
"," +
that.plate_no +
"," +
that.personid +
"," +
that.location
);

that.$http.post(url).then((ret) => {
console.log(JSON.stringify(ret));
if (ret.data.code == 0) {
that.$vux.alert.show({
title: "绑定成功",
content: ret.data.message,
onShow() {},
onHide() {
that.$router.push("/ScanQR");
},
});

} else {
that.$vux.alert.show({
title: "绑定失败",
content: ret.data.message,
onShow() {},
onHide() {},
});
}
});
},
},
mounted() {
this.init();
},
data() {
return {
history_data: [],
personid: "",
wx_id: "",
phone: "",
plate_no: "",
carNum: "",
location: "",
location_list: [
{ key: "ningming", value: "宁明" },
{ key: "haitang", value: "海棠" },
],
};
},
};



// WEBPACK FOOTER //
// ./src/components/CheckId.vue